
import React from "react";
import "./home.scss";
import "../../assets/scss/main.scss";

export default function ListDetails() {
  return (
    <>
    </>
  );
}
